/**
 * License-duration options for the admin code-generation surfaces (OCP-460).
 *
 * Mirrors the API enum in `apps/api/src/lib/license-duration.ts`. Both the
 * invite-codes generate dialog and the waitlist invite template render a
 * constrained `<select>` from this list instead of a free-form text field,
 * so an operator can never enter an unparseable duration that silently ships
 * the wrong license length. `lifetime` maps to a NULL expiry server-side.
 */
export type LicenseDurationValue =
  | '1_month'
  | '3_months'
  | '6_months'
  | '1_year'
  | '2_years'
  | 'lifetime';

export interface LicenseDurationOption {
  value: LicenseDurationValue;
  label: string;
}

export const LICENSE_DURATION_OPTIONS: readonly LicenseDurationOption[] = [
  { value: '1_month', label: '1 month' },
  { value: '3_months', label: '3 months' },
  { value: '6_months', label: '6 months' },
  { value: '1_year', label: '1 year' },
  { value: '2_years', label: '2 years' },
  { value: 'lifetime', label: 'lifetime' },
];

/** Default selection for both generate surfaces. */
export const DEFAULT_LICENSE_DURATION: LicenseDurationValue = '6_months';
